
(function () {
  'use strict';

  function calculateSoil() {
    var calculator = document.getElementById('dls-soil-calculator');
    if (!calculator) return;

    var lengthInput = document.getElementById('dls-soil-length');
    var widthInput = document.getElementById('dls-soil-width');
    var depthInput = document.getElementById('dls-soil-depth');
    var bagsEl = document.getElementById('dls-soil-bags');
    var labelEl = document.getElementById('dls-soil-bag-label');
    var detailsEl = document.getElementById('dls-soil-details');

    if (!lengthInput || !widthInput || !depthInput ||
        !bagsEl || !labelEl || !detailsEl) return;

    var length = parseFloat(lengthInput.value);
    var width = parseFloat(widthInput.value);
    var depth = parseFloat(depthInput.value);

    if (!Number.isFinite(length) ||
        !Number.isFinite(width) ||
        !Number.isFinite(depth) ||
        length <= 0 || width <= 0 || depth <= 0) {
      bagsEl.textContent = '—';
      labelEl.textContent = 'Bulk Bags';
      detailsEl.textContent =
        'Enter positive measurements to calculate.';
      return;
    }

    var area = length * width;
    var yards = area * depth / 324;
    var bags = Math.ceil(yards);

    bagsEl.textContent = bags.toLocaleString();
    labelEl.textContent = bags === 1 ? 'Bulk Bag' : 'Bulk Bags';

    detailsEl.textContent =
      area.toLocaleString(undefined, {
        maximumFractionDigits: 2
      }) +
      ' sq. ft. at ' + depth +
      ' inches deep = ' + yards.toFixed(2) +
      ' cubic yards';
  }

  function initializeCalculators() {
    var calculator = document.getElementById('dls-soil-calculator');
    if (!calculator || calculator.dataset.dlsInitialized === 'true') {
      return;
    }

    calculator.dataset.dlsInitialized = 'true';

    ['dls-soil-length', 'dls-soil-width', 'dls-soil-depth']
      .forEach(function (id) {
        var input = document.getElementById(id);
        if (input) {
          input.removeAttribute('oninput');
          input.addEventListener('input', calculateSoil);
          input.addEventListener('change', calculateSoil);
        }
      });

    calculateSoil();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCalculators);
  } else {
    initializeCalculators();
  }
})();
